import { ViewAuditioneesTab2 } from "./sub_tabs/ViewAuditioneesTab2";


const mergeAuditioneesTabRouter2 = {

  duplicates: 
  {
    title: 'Duplicates',
    element: <ViewAuditioneesTab2 />
  }

}

export default mergeAuditioneesTabRouter2;